import "bulma/css/bulma.min.css";
import { React } from "react";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import { RecoilRoot } from "recoil";
import "./index.css";

import Dashboard from "./Components/Dashboard/Dashboard";
import Index from "./Components/Gateway/Index";
import Login from "./Components/Gateway/Login";
import LogoutRedirector from "./Components/Gateway/LogoutRedirector";
import Sidebar from "./Components/Menu/Sidebar";
import Topbar from "./Components/Menu/Top";
import TopAlertBanner from "./Components/Misc/TopAlertBanner";

import ImageAdd from "./Components/Image/Add";
import ImageDetail from "./Components/Image/Detail";
import ImageList from "./Components/Image/List";
import ImageUpdate from "./Components/Image/Update";
import NotFoundError from "./Components/Misc/NotFoundError";
import AddOrganization from "./Components/Organization/add";
import Organization from "./Components/Organization/organization";
import AddPromoCode from "./Components/PromoCode/add";
import PromoCode from "./Components/PromoCode/promo-code";
import EditorPage from "./Components/Resources/editor";
import Resources from "./Components/Resources/resources";
import SessionTemplateAdd from "./Components/SessionTemplate/Add";
import SessionTemplateBreathworkOptionAdd from "./Components/SessionTemplate/BreathingOption/Add";
import SessionTemplateBreathworkOptionDetail from "./Components/SessionTemplate/BreathingOption/Detail";
import SessionTemplateBreathworkOptionUpdate from "./Components/SessionTemplate/BreathingOption/Update";
import SessionTemplateDetail from "./Components/SessionTemplate/Detail";
import SessionTemplateDetailForBreathworkOption from "./Components/SessionTemplate/DetailForBreathworkOption";
import SessionTemplateDetailForSleepQuestion from "./Components/SessionTemplate/DetailForSleepQuestion";
import SessionTemplateDetailForVideoSection from "./Components/SessionTemplate/DetailForVideoSection";
import SessionTemplateList from "./Components/SessionTemplate/List";
import SessionTemplateSleepQuestionAdd from "./Components/SessionTemplate/SleepQuestion/Add";
import SessionTemplateSleepQuestionDetail from "./Components/SessionTemplate/SleepQuestion/Detail";
import SessionTemplateSleepQuestionUpdate from "./Components/SessionTemplate/SleepQuestion/Update";
import SessionTemplateUpdate from "./Components/SessionTemplate/Update";
import SessionTemplateVideoSectionAdd from "./Components/SessionTemplate/VideoSection/Add";
import SessionTemplateVideoSectionDetail from "./Components/SessionTemplate/VideoSection/Detail";
import SessionTemplateVideoSectionDetailForExerciseList from "./Components/SessionTemplate/VideoSection/DetailForExerciseList";
import SessionTemplateVideoSectionExerciseAdd from "./Components/SessionTemplate/VideoSection/Exercise/Add";
import SessionTemplateVideoSectionExerciseDelete from "./Components/SessionTemplate/VideoSection/Exercise/Delete";
import SessionTemplateVideoSectionExerciseDetail from "./Components/SessionTemplate/VideoSection/Exercise/Detail";
import SessionTemplateVideoSectionExerciseUpdate from "./Components/SessionTemplate/VideoSection/Exercise/Update";
import SessionTemplateVideoSectionUpdate from "./Components/SessionTemplate/VideoSection/Update";
import UserAdd from "./Components/User/Add";
import UserDetail from "./Components/User/Detail";
import UserDetailForReportList from "./Components/User/DetailForReportList";
import UserDetailForSessionList from "./Components/User/DetailForSessionList";
import UserList from "./Components/User/List";
import UserReportDetail from "./Components/User/Report/Detail";
import UserSessionAdd from "./Components/User/Session/Add";
import UserSessionBreathworkOptionAdd from "./Components/User/Session/BreathingOption/Add";
import UserSessionBreathworkOptionDetail from "./Components/User/Session/BreathingOption/Detail";
import UserSessionBreathworkOptionUpdate from "./Components/User/Session/BreathingOption/Update";
import UserSessionDetail from "./Components/User/Session/Detail";
import UserSessionDetailForBreathworkOption from "./Components/User/Session/DetailForBreathworkOption";
import UserSessionDetailForSleepQuestion from "./Components/User/Session/DetailForSleepQuestion";
import UserSessionDetailForVideoSection from "./Components/User/Session/DetailForVideoSection";
import UserSessionSleepQuestionAdd from "./Components/User/Session/SleepQuestion/Add";
import UserSessionSleepQuestionDetail from "./Components/User/Session/SleepQuestion/Detail";
import UserSessionSleepQuestionUpdate from "./Components/User/Session/SleepQuestion/Update";
import UserSessionUpdate from "./Components/User/Session/Update";
import UserSessionVideoSectionAdd from "./Components/User/Session/VideoSection/Add";
import UserSessionVideoSectionDetail from "./Components/User/Session/VideoSection/Detail";
import UserSessionVideoSectionExerciseDetailForExercise from "./Components/User/Session/VideoSection/DetailForExercise";
import UserSessionVideoSectionExerciseAdd from "./Components/User/Session/VideoSection/Exercise/Add";
import UserSessionVideoSectionExerciseDetail from "./Components/User/Session/VideoSection/Exercise/Detail";
import UserSessionVideoSectionExerciseUpdate from "./Components/User/Session/VideoSection/Exercise/Update";
import UserSessionVideoSectionUpdate from "./Components/User/Session/VideoSection/Update";
import UserUpdate from "./Components/User/Update";
import UserUpdateForChangePassword from "./Components/User/UpdateForChangePassword";
import VideoAdd from "./Components/Video/Add";
import VideoDetail from "./Components/Video/Detail";
import VideoList from "./Components/Video/List";
import VideoUpdate from "./Components/Video/Update";
import PromoCodeDetail from "./Components/PromoCode/detail";
import OrganizationDetail from "./Components/Organization/details";
import OrgUserList from "./Orgnization/User/List";
import OrgUserAdd from "./Orgnization/User/Add";
import OrgPromoCode from "./Orgnization/PromoCode/promo-code";
import AddOrgPromoCode from "./Orgnization/PromoCode/add";
import OrgPromoCodeDetail from "./Orgnization/PromoCode/detail";
import OrgUserDetailForSessionList from "./Orgnization/User/DetailForSessionList";
import { useAuthStore } from "./stores/auth-store";
import OrgUserDetail from "./Orgnization/User/Detail";
import OrgDashboard from "./Orgnization/Org-Dashboard/Org-Dashboard";
import OrgUserSessionAdd from "./Orgnization/User/Session/Add";
import OrgActivities from "./Orgnization/User/Activities/activities";
import Activities from "./Components/User/Activities/activities";

function AppRoute() {
  const PrivateRoute = ({ allowedRoles, children }) => {
    const user = useAuthStore((store) => store.user);

    if (!user?.role || !allowedRoles?.includes(user.role)) {
      return <Navigate to="/login" replace />;
    }

    return children;
  };
  return (
    <div class="is-widescreen">
      <RecoilRoot>
        <Router>
          <TopAlertBanner />
          <Topbar />
          <div class="columns">
            <Sidebar />
            <div class="column">
              <section class="main-content columns is-fullheight">
                <Routes>
                  <Route exact path="/login" element={<Login />} />
                  <Route exact path="/logout" element={<LogoutRedirector />} />
                  <Route exact path="/" element={<Index />} />
                  <Route path="*" element={<NotFoundError />} />

                  {/* admin routers */}

                  <Route
                    exact
                    path="/dashboard"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <Dashboard />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/resources"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <Resources />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/editor"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <EditorPage />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/organization"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <Organization />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/organization/add"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <AddOrganization />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/organization/details/:id"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <OrganizationDetail />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/promo-code"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <PromoCode />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/promo-code/add"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <AddPromoCode />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/promo-code/:id"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <AddPromoCode />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/promo-code/details/:id"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <PromoCodeDetail />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/session-templates"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <SessionTemplateList />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/session-templates/add"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <SessionTemplateAdd />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/session-template/:id"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <SessionTemplateDetail />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/session-template/:id/video-sections"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <SessionTemplateDetailForVideoSection />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/session-template/:sid/breathwork-options"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <SessionTemplateDetailForBreathworkOption />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/session-template/:sid/breathwork-options/add"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <SessionTemplateBreathworkOptionAdd />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/session-template/:sid/breathwork-option/:boid/edit"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <SessionTemplateBreathworkOptionUpdate />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/session-template/:sid/breathwork-option/:boid"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <SessionTemplateBreathworkOptionDetail />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/session-template/:sid/sleep-questions"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <SessionTemplateDetailForSleepQuestion />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/session-template/:sid/sleep-questions/add"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <SessionTemplateSleepQuestionAdd />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/session-template/:sid/sleep-question/:sqIndex"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <SessionTemplateSleepQuestionDetail />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/session-template/:sid/sleep-question/:sqIndex/edit"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <SessionTemplateSleepQuestionUpdate />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/session-template/:sid/video-section/add"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <SessionTemplateVideoSectionAdd />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/session-template/:id/video-section/:vsIndex"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <SessionTemplateVideoSectionDetail />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/session-template/:id/video-section/:vsIndex/exercises"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <SessionTemplateVideoSectionDetailForExerciseList />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/session-template/:id/video-section/:vsIndex/edit"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <SessionTemplateVideoSectionUpdate />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/session-template/:id/video-section/:vsIndex/exercise/:eIndex"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <SessionTemplateVideoSectionExerciseDetail />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/session-template/:id/video-section/:vsIndex/exercise/:eIndex/edit"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <SessionTemplateVideoSectionExerciseUpdate />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/session-template/:id/video-section/:vsIndex/exercise/:eIndex/delete"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <SessionTemplateVideoSectionExerciseDelete />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/session-template/:id/video-section/:vsIndex/exercises/add"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <SessionTemplateVideoSectionExerciseAdd />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/session-template/:id/edit"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <SessionTemplateUpdate />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/cms-videos"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <VideoList />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/cms-videos/add"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <VideoAdd />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/cms-video/:id"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <VideoDetail />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/cms-video/:id/edit"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <VideoUpdate />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/cms-images"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <ImageList />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/cms-images/add"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <ImageAdd />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/cms-image/:id"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <ImageDetail />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/cms-image/:id/edit"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <ImageUpdate />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/users"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <UserList />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/users/add"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <UserAdd />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/user/:id"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <UserDetail />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/user/:id/edit"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <UserUpdate />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/user/:id/change-password"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <UserUpdateForChangePassword />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/user/:uid/reports"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <UserDetailForReportList />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/user/:uid/report/:rid"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <UserReportDetail />
                      </PrivateRoute>
                    }
                  />
                   <Route
                    exact
                    path="/user/:uid/activities"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <Activities />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/user/:uid/sessions"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <UserDetailForSessionList />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/user/:uid/sessions/add"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <UserSessionAdd />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/user/:uid/session/:sid"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <UserSessionDetail />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/user/:uid/session/:sid/edit"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <UserSessionUpdate />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/user/:uid/session/:sid/breathwork-option/:boid/edit"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <UserSessionBreathworkOptionUpdate />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/user/:uid/session/:sid/breathwork-option/:boid"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <UserSessionBreathworkOptionDetail />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/user/:uid/session/:sid/breathwork-options/add"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <UserSessionBreathworkOptionAdd />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/user/:uid/session/:sid/breathwork-options"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <UserSessionDetailForBreathworkOption />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/user/:uid/session/:sid/sleep-question/:sqid/edit"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <UserSessionSleepQuestionUpdate />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/user/:uid/session/:sid/sleep-question/:sqid"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <UserSessionSleepQuestionDetail />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/user/:uid/session/:sid/sleep-questions/add"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <UserSessionSleepQuestionAdd />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/user/:uid/session/:sid/sleep-questions"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <UserSessionDetailForSleepQuestion />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/user/:uid/session/:sid/video-sections"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <UserSessionDetailForVideoSection />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/user/:uid/session/:sid/video-sections/add"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <UserSessionVideoSectionAdd />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/user/:uid/session/:sid/video-section/:vsid"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <UserSessionVideoSectionDetail />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/user/:uid/session/:sid/video-section/:vsid/edit"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <UserSessionVideoSectionUpdate />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/user/:uid/session/:sid/video-section/:vsid/exercise/:eid/edit"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <UserSessionVideoSectionExerciseUpdate />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/user/:uid/session/:sid/video-section/:vsid/exercise/:eid"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <UserSessionVideoSectionExerciseDetail />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/user/:uid/session/:sid/video-section/:vsid/exercises/add"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <UserSessionVideoSectionExerciseAdd />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/user/:uid/session/:sid/video-section/:vsid/exercises"
                    element={
                      <PrivateRoute allowedRoles={["admin"]}>
                        <UserSessionVideoSectionExerciseDetailForExercise />
                      </PrivateRoute>
                    }
                  />

                  {/* orgnization routes */}

                  <Route
                    exact
                    path="/org-dashboard"
                    element={
                      <PrivateRoute allowedRoles={["organization"]}>
                        <OrgDashboard />
                      </PrivateRoute>
                    }
                  />

                  <Route
                    exact
                    path="/org-users"
                    element={
                      <PrivateRoute allowedRoles={["organization"]}>
                        <OrgUserList />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/org-user/add"
                    element={
                      <PrivateRoute allowedRoles={["organization"]}>
                        <OrgUserAdd />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/org-user/:id"
                    element={
                      <PrivateRoute allowedRoles={["organization"]}>
                        <OrgUserDetail />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/org-user/:id/edit"
                    element={
                      <PrivateRoute allowedRoles={["organization"]}>
                        <UserUpdate />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/org-user/:id/change-password"
                    element={
                      <PrivateRoute allowedRoles={["organization"]}>
                        <UserUpdateForChangePassword />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/org-user/:uid/reports"
                    element={
                      <PrivateRoute allowedRoles={["organization"]}>
                        <UserDetailForReportList />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/org-user/:uid/report/:rid"
                    element={
                      <PrivateRoute allowedRoles={["organization"]}>
                        <UserReportDetail />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/org-user/:uid/sessions"
                    element={
                      <PrivateRoute allowedRoles={["organization"]}>
                        <OrgUserDetailForSessionList />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/org-user/:uid/activities"
                    element={
                      <PrivateRoute allowedRoles={["organization"]}>
                        <OrgActivities />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/org-user/:uid/sessions/add"
                    element={
                      <PrivateRoute allowedRoles={["organization"]}>
                        <OrgUserSessionAdd />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/org-user/:uid/session/:sid"
                    element={
                      <PrivateRoute allowedRoles={["organization"]}>
                        <UserSessionDetail />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/org-user/:uid/session/:sid/edit"
                    element={
                      <PrivateRoute allowedRoles={["organization"]}>
                        <UserSessionUpdate />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/org-user/:uid/session/:sid/breathwork-option/:boid/edit"
                    element={
                      <PrivateRoute allowedRoles={["organization"]}>
                        <UserSessionBreathworkOptionUpdate />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/org-user/:uid/session/:sid/breathwork-option/:boid"
                    element={
                      <PrivateRoute allowedRoles={["organization"]}>
                        <UserSessionBreathworkOptionDetail />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/org-user/:uid/session/:sid/breathwork-options/add"
                    element={
                      <PrivateRoute allowedRoles={["organization"]}>
                        <UserSessionBreathworkOptionAdd />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/org-user/:uid/session/:sid/breathwork-options"
                    element={
                      <PrivateRoute allowedRoles={["organization"]}>
                        <UserSessionDetailForBreathworkOption />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/org-user/:uid/session/:sid/sleep-question/:sqid/edit"
                    element={
                      <PrivateRoute allowedRoles={["organization"]}>
                        <UserSessionSleepQuestionUpdate />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/org-user/:uid/session/:sid/sleep-question/:sqid"
                    element={
                      <PrivateRoute allowedRoles={["organization"]}>
                        <UserSessionSleepQuestionDetail />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/org-user/:uid/session/:sid/sleep-questions/add"
                    element={
                      <PrivateRoute allowedRoles={["organization"]}>
                        <UserSessionSleepQuestionAdd />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/org-user/:uid/session/:sid/sleep-questions"
                    element={
                      <PrivateRoute allowedRoles={["organization"]}>
                        <UserSessionDetailForSleepQuestion />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/org-user/:uid/session/:sid/video-sections"
                    element={
                      <PrivateRoute allowedRoles={["organization"]}>
                        <UserSessionDetailForVideoSection />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/org-user/:uid/session/:sid/video-sections/add"
                    element={
                      <PrivateRoute allowedRoles={["organization"]}>
                        <UserSessionVideoSectionAdd />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/org-user/:uid/session/:sid/video-section/:vsid"
                    element={
                      <PrivateRoute allowedRoles={["organization"]}>
                        <UserSessionVideoSectionDetail />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/org-user/:uid/session/:sid/video-section/:vsid/edit"
                    element={
                      <PrivateRoute allowedRoles={["organization"]}>
                        <UserSessionVideoSectionUpdate />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/org-user/:uid/session/:sid/video-section/:vsid/exercise/:eid/edit"
                    element={
                      <PrivateRoute allowedRoles={["organization"]}>
                        <UserSessionVideoSectionExerciseUpdate />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/org-user/:uid/session/:sid/video-section/:vsid/exercise/:eid"
                    element={
                      <PrivateRoute allowedRoles={["organization"]}>
                        <UserSessionVideoSectionExerciseDetail />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/org-user/:uid/session/:sid/video-section/:vsid/exercises/add"
                    element={
                      <PrivateRoute allowedRoles={["organization"]}>
                        <UserSessionVideoSectionExerciseAdd />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/org-user/:uid/session/:sid/video-section/:vsid/exercises"
                    element={
                      <PrivateRoute allowedRoles={["organization"]}>
                        <UserSessionVideoSectionExerciseDetailForExercise />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/org-promo-code"
                    element={
                      <PrivateRoute allowedRoles={["organization"]}>
                        <OrgPromoCode />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/org-promo-code/add"
                    element={
                      <PrivateRoute allowedRoles={["organization"]}>
                        <AddOrgPromoCode />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/org-promo-code/:id"
                    element={
                      <PrivateRoute allowedRoles={["organization"]}>
                        <AddPromoCode />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    exact
                    path="/org-promo-code/details/:id"
                    element={
                      <PrivateRoute allowedRoles={["organization"]}>
                        <OrgPromoCodeDetail />
                      </PrivateRoute>
                    }
                  />
                </Routes>
              </section>
              <div>
                {/* DEVELOPERS NOTE: Mobile tab-bar menu can go here */}
              </div>
              <footer class="footer is-hidden">
                <div class="container">
                  <div class="content has-text-centered">
                    <p>Hello</p>
                  </div>
                </div>
              </footer>
            </div>
          </div>
        </Router>
      </RecoilRoot>
    </div>
  );
}

export default AppRoute;
